<template>
	<div class="lobby-theme-footer">
		<div class="lobby-theme-footer-inner">
			<div class="container">
				<div class="row">
					<div class="col-xs-12">
						<div class="footer-inner">
							<div class="visible-pc">
								<div class="mt10">{{$store.state.copyright}}</div>
								<div>
									{{$store.state.address}}
								</div>
							</div>
							<div class="visible-mobile">
								<div class="mt10">{{$store.state.copyright}}</div>
								<div>
									{{$store.state.address}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

	export default {
		data () {
			return {
				user: this.$store.state.user
			}
		},
		props: {},
		computed: {},
		components: {},
		methods: {},
		watch: {},
		mounted(){
		}
	}
</script>


<style lang="less" rel="stylesheet/less">


	.lobby-theme-footer {

		@font-color: #ddd;
		@main-color: #333;

		@import "./css/FooterView";

	}


</style>



// WEBPACK FOOTER //
// FooterView.vue?2c243202